import React from "react"
import styled from "styled-components"
import MailTo from "./MailTo"
import SocialMedia from "./SocialMedia"
import Privacy from "./Privacy"
import { motion } from "framer-motion"
import { pageAnimation } from "../../utils/animations"

export default function Footer() {
  return (
    <Wrapper
      className="section-center"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <div className="footer-center">
        <MailTo />
        <p>Chaica, Puerto Montt, Región de los Lagos</p>
        <SocialMedia />
      </div>
      <Privacy />
    </Wrapper>
  )
}

const Wrapper = styled(motion.section)`
  text-align: center;

  .footer-center {
    padding: 2rem 1rem;
    border-width: 1px 0;
    border-style: solid;
    border-color: var(--primary-500);
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    font-weight: bold;
    margin-bottom: 0;
    & p {
      margin-bottom: 0;
    }
  }

  @media screen and (min-width: 992px) {
    .footer-center {
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
    }
  }
`
